import { render, staticRenderFns } from "./EtransactElectricityWallet.vue?vue&type=template&id=8c328aca&scoped=true"
import script from "./EtransactElectricityWallet.vue?vue&type=script&lang=js"
export * from "./EtransactElectricityWallet.vue?vue&type=script&lang=js"
import style0 from "./EtransactElectricityWallet.vue?vue&type=style&index=0&id=8c328aca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c328aca",
  null
  
)

export default component.exports